import React, { Suspense, useState } from 'react';
import { Bottom, SkillsBox, Skillbody, Top, SkillIcon, Box, BigBox, Book, BookWrapper, Shelf, Header, Container, LeftBox, RightBox, BookBack } from './Styled';
import { SkillList, Skills } from '../../Components/Utils';
import Skillicon from '../../Assets/skill6.svg';

//
import { Canvas } from '@react-three/fiber';
import { Physics } from '@react-three/rapier';
import Experience from './Experience';
import OpenBook from './OpenBook';

const Index = () => {

    // STANDING MAN FACE LEFT HAVING BOOKSHELF THRILLERS
    const [ativeBook, setActiveBook] = useState(false);
    const [activeBookId, setActiveBookId] = useState(null);
    const [selectedData,setSelectedData]=useState([]);
    return (
        <Skillbody >
            <Bottom>
                {ativeBook && <OpenBook data={selectedData} onClose={() => { setActiveBook(false); setActiveBookId(null) }} />}
                <Container>
                    <Header>
                        <LeftBox>
                            <h2 className='shelfHead'>SKILLS</h2>
                        </LeftBox>
                    </Header>

                    {/* Shelves */}
                    {Skills?.map((data) => {
                        return (
                            <Shelf>
                                {data?.map((subdata) => (
                                    <BookWrapper>
                                        <Book
                                            cover={subdata?.background}
                                            Tcolor={subdata?.color}
                                            active={activeBookId === subdata?.id}
                                            onClick={() => {
                                                setActiveBookId(subdata?.id);
                                                setSelectedData(subdata);
                                                setTimeout(() => {
                                                    setActiveBook(true); // show OpenBook after 1 second
                                                }, 1300); // 1000ms = 1 second
                                            }}
                                        >
                                            <img className='skilllogo' src={subdata?.logo} />
                                            <p className='BookTitle'>{subdata?.skill}</p>
                                            {/* <div class="book-side bookfront"></div> */}
                                        </Book>
                                        <BookBack class="book-side bookback" active={activeBookId === subdata?.id}></BookBack>

                                    </BookWrapper>
                                ))}
                            </Shelf>)
                    })}
                </Container>
                <SkillIcon src={Skillicon} />
            </Bottom>
        </Skillbody>
    );
}

export default Index;

